import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWhatsapp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <rect
      width={32}
      height={32}
      fill="#00C5F2"
      rx={16}
    />
    <g clipPath="url(#Whatsapp_svg__a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M22.377 9.614A8.93 8.93 0 0 0 16.037 7c-4.94 0-8.96 3.998-8.962 8.912 0 1.571.412 3.105 1.197 4.456L7 24.987l4.751-1.24a9 9 0 0 0 4.283 1.085h.004c4.94 0 8.96-3.998 8.962-8.913 0-2.381-.93-4.62-2.623-6.305m-6.34 13.713h-.002a7.47 7.47 0 0 1-3.792-1.033l-.272-.16-2.82.735.753-2.734-.177-.28a7.36 7.36 0 0 1-1.139-3.942c.002-4.085 3.344-7.408 7.453-7.408 1.99.001 3.86.772 5.266 2.173a7.34 7.34 0 0 1 2.18 5.24c-.002 4.085-3.343 7.409-7.45 7.409m4.087-5.548c-.224-.112-1.325-.65-1.53-.724-.206-.075-.355-.112-.504.111s-.579.725-.71.873c-.13.149-.26.167-.485.056-.223-.112-.945-.347-1.8-1.105-.666-.591-1.116-1.32-1.246-1.543s-.014-.344.098-.454c.1-.1.224-.26.336-.39s.149-.224.224-.372c.074-.149.037-.279-.019-.39-.056-.112-.503-1.208-.69-1.654-.182-.434-.367-.375-.504-.382a9 9 0 0 0-.43-.008.82.82 0 0 0-.597.279c-.205.223-.784.762-.784 1.858 0 1.095.803 2.155.915 2.304.112.148 1.58 2.397 3.825 3.362.535.23.952.367 1.277.47.537.17 1.025.145 1.41.088.43-.064 1.325-.539 1.512-1.059.186-.52.186-.966.13-1.059s-.205-.149-.429-.26z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Whatsapp_svg__a">
        <path
          fill="#fff"
          d="M7 7h18v18H7z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWhatsapp);

export default ForwardRef;
